<template>
  <form ref="searchForm" @submit.prevent="submit">
    <div class="search_row mb-5 px-8">
      <p>검색어</p>
      <v-row no-gutters>
        <v-col class="pr-4" cols="3">
          <v-text-field
            v-model="form.solNameOrSolNumber"
            background-color="inputBG"
            outlined
            height="48"
            append-icon="mdi-magnify"
            placeholder="이름 혹은 연락처"
            dense
            @keydown.enter.prevent="submit"></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="search_row mb-5 px-8">
      <p>필터</p>
      <v-row no-gutters>
        <v-col class="d-flex pr-4" cols="3">
          <select-box v-model="form.latestState" :items="oralStatus" placeholder="최근 잇몸상태"></select-box>
        </v-col>
        <v-col class="d-flex pr-4" cols="3">
          <select-box v-model="form.solGender" :items="genderStatus" placeholder="성별"></select-box>
        </v-col>
        <v-col class="d-flex pr-4" cols="3">
          <select-box v-model="form.isCertified" :items="certStatus" placeholder="회원여부"></select-box>
        </v-col>
      </v-row>
    </div>
    <date-filter v-model="selectedDate" title="최근 촬영일"></date-filter>
    <div class="pt-5 px-8 submit_btn_row d-flex justify-end">
      <v-btn color="white" height="44" class="reset_btn mr-4 d-flex justify-center align-center" @click="reset">
        <i class="icon reset mr-1"></i>
        초기화
      </v-btn>
      <v-btn color="primaryDark" height="44" class="submit_btn" @click="submit">검색</v-btn>
    </div>
  </form>
</template>

<script>
import SelectBox from '@/components/common/SelectBox';
import DateFilter from '@/components/forms/DateFilter';
import { mapState } from 'vuex';

export default {
  name: 'SearchForm',
  components: {
    SelectBox,
    DateFilter,
  },
  data: () => ({
    form: {
      solNameOrSolNumber: '',
      corId: '',
      latestState: '',
      solGender: '',
      isCertified: '',
      startDate: '',
      endDate: '',
    },
    selectedDate: {
      startDate: '',
      endDate: '',
      active: '',
    },
  }),
  computed: {
    ...mapState('commonValue', ['corpsList', 'oralStatus', 'genderStatus', 'certStatus']),
  },
  created() {
    Object.assign(this.form, this.$route.query);
    if (this.$route.query.corId) this.form.corId = Number(this.$route.query.corId);
    for (const i in this.selectedDate) {
      if (this.form[i]) {
        this.selectedDate[i] = this.form[i];
      }
    }
  },
  methods: {
    reset() {
      let self = this;
      Object.keys(this.form).forEach(function (key) {
        self.form[key] = '';
      });
      Object.keys(this.selectedDate).forEach(function (key) {
        self.selectedDate[key] = '';
      });
      this.$emit('reset');
    },
    submit() {
      delete this.form.page; // 검색 시 1페이지로 초기화
      this.form = Object.assign(this.form, this.selectedDate);
      this.$emit('search', this.form);
    },
  },
};
</script>

<style scoped></style>
